
import { Component, Vue } from 'vue-property-decorator'
import { format } from 'date-fns'

import PasswordPrompt from '@/components/user/settings/PasswordPrompt.vue'
import LConfirmDialog from '@/global-components/LConfirmDialog.vue'
import { authModule, eventModule } from '@/store'
import { User, UserUpdateInput } from '@/types/user'
import { TextFieldRules } from '@/utils/enums'
import { getLocalStorageString, isBrowser } from '@/utils/utility-manager'
import { formattedDate } from '@/utils/date-utils'
import { useSignOut } from '@/composables/auth'
@Component({
  name: 'ProfileExpansionPanel',
  components: {
    PasswordPrompt,
    LConfirmDialog,
  },
  setup() {
    const { signOut } = useSignOut()
    return { signOut }
  },
})
class ProfileExpansionPanel extends Vue {
  rules = TextFieldRules
  localUser: User = JSON.parse(JSON.stringify(authModule.user))
  showCalendar = false
  selectedDateFormat = ''
  signOut!: ReturnType<typeof useSignOut>['signOut']

  countries = Object.keys(require('~/assets/json/_countries/en.json')).map(
    (el) => {
      return { code: el, text: require('~/assets/json/_countries/en.json')[el] }
    },
  )

  dateFormats: { text: string; value: string }[] = [
    { text: 'DD.MM.YYYY', value: 'dd.MM.yyyy' },
    { text: 'DD/MM/YYYY', value: 'dd/MM/yyyy' },
    { text: 'MM/DD/YYYY', value: 'MM/dd/yyyy' },
    { text: 'DD/MM/YYYY', value: 'dd/MM/yyyy' },
    { text: 'YYYY/MM/DD', value: 'yyyy/MM/dd' },
  ]

  get dateFormatItems() {
    const today = new Date()
    const values = this.dateFormats.map((_format) => {
      return {
        text: `${_format.text} (${format(today, _format.value)})`,
        value: _format.value,
      }
    })

    values.splice(0, 0, {
      text: `${this.$t('systemFormat')} (${formattedDate(today)})`,
      value: 'system',
    })

    return values
  }

  get user() {
    this.localUser = JSON.parse(JSON.stringify(authModule.user))
    return authModule.user
  }

  get userBirthDate() {
    return this.localUser.birthDate
      ? formattedDate(this.localUser.birthDate)
      : ''
  }

  get userCountryCode() {
    return this.localUser.country?.code || ''
  }

  set userCountryCode(code: string) {
    if (this.localUser.country) {
      Object.assign(this.localUser.country, { code })
    } else {
      Object.assign(this.localUser, { country: { code } })
    }
  }

  mounted() {
    this.selectedDateFormat = getLocalStorageString(
      'kLambusPreferredDateFormat',
      'system',
    )
  }

  setSelectedDateFormat(format: string): void {
    if (isBrowser()) {
      localStorage.setItem('kLambusPreferredDateFormat', format)
    }
  }

  showPasswordPrompt(): void {
    const dialog = this.$refs.passwordPrompt as PasswordPrompt
    setTimeout(() => {
      if (dialog) dialog.toggleDialog()
    })
  }

  showDeleteAccountPrompt(): void {
    const dialog = this.$refs.confirmDialog as LConfirmDialog
    if (dialog) {
      dialog.toggleDialog()
    }
  }

  async deleteAccount(): Promise<void> {
    try {
      const result = await this.$axios.delete(`/api/users/${this.user.id}`, {
        params: { userId: this.user.id },
      })

      if (result.data.success) {
        this.signOut()
      }
    } catch (error) {
      eventModule.newError('error.user.delete')
    }
  }

  async updateProfile() {
    const validProfileUpdateKeys = [
      'firstName',
      'lastName',
      'email',
      'username',
      'paypalEmailAddress',
      'paypalMeUsername',
      'gender',
      'birthDate',
    ] as const

    const modifiedUserData: UserUpdateInput = {}

    for (const key of validProfileUpdateKeys) {
      if (this.localUser[key] !== authModule.user[key]) {
        modifiedUserData[key] = this.localUser[key] as any
      }
    }

    if (this.localUser.country?.code !== authModule.user.country?.code) {
      modifiedUserData.country = this.localUser.country.code
    }

    await authModule.updateProfile(modifiedUserData)
  }
}
export default ProfileExpansionPanel
